import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Dubai from "../../assets/New/dubai.jpg";
import Ajman from "../../assets/New/Ajman.jpg";
import Ras from "../../assets/New/Ras.jpg";
import sharjah from "../../assets/New/sharjah.jpg";
import Umm from "../../assets/New/Umm.webp";
// import Al_Majaz_Sharjah_waterfront_skyline from "../../assets/area/Al_Majaz_Sharjah_waterfront_skyline.webp";
// import Al_Mamsha_Sharjah_modern_apartments from "../../assets/area/Al_Mamsha_Sharjah_modern_apartments.jpg";
// import Aljada_Sharjah_master_plan_aerial from "../../assets/area/Aljada_Sharjah_master_plan_aerial.jpg";
import buyers1 from "../../assets/dubai-buy.jpg";

const cards = [
  {
    eyebrow: "Dubai",
    title: "Dubai",
    image: Dubai,
  },
  {
    eyebrow: "Sharjah",
    title: "Sharjah",
    image: sharjah,
  },
  {
    eyebrow: "Ras Al Khaimah",
    title: "Ras Al Khaimah",
    image: Ras,
  },
  {
    eyebrow: "Ajman",
    title: "Ajman",
    image: Ajman,
  },
  {
    eyebrow: "Umm Al Quwain",
    title: "Umm Al Quwain",
    image: Umm,
  },
];

export function PremiumBuyerRightCollage() {
  return (
    <Box
      sx={{
        display: "flex",
        gap: { xs: 2.5, md: 3 },
        height: { xs: 420, md: 520 },
        overflowX: { xs: "auto", md: "hidden" },
        scrollSnapType: { xs: "x mandatory", md: "none" },
        px: { xs: 1, md: 0 },
      }}
    >
      {cards.map((item, i) => (
        <Box
          key={i}
          component={motion.div}
          whileHover={{ flex: 5 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
          sx={{
            position: "relative",
            flex: 1,
            minWidth: { xs: "80%", md: "auto" },
            borderRadius: "32px",
            overflow: "hidden",
            cursor: "pointer",
            scrollSnapAlign: "start",
            // boxShadow: "0 30px 70px rgba(0,0,0,0.25)",
          }}
          className="premium-card"
        >
          {/* IMAGE */}
          <Box
            component="img"
            src={item.image}
            alt={item.title}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.6s ease",
            }}
          />

          {/* TEXT */}
          {/* TEXT + LOCAL GRADIENT */}
          <Box
            className="card-text"
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,

              // 🔥 Gradient ONLY behind text
              background:
                "linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.75))",

              padding: "26px",
              color: "#fff",

              // desktop hover logic
              opacity: { xs: 1, md: 0 },
              transform: { md: "translateY(12px)" },
              transition: "all 0.4s ease",
              pointerEvents: "none",

              // ✅ only this card hover
              ".premium-card:hover &": {
                opacity: 1,
                transform: "translateY(0)",
              },
            }}
          >
            {/* <Typography
              sx={{
                fontSize: 12,
                letterSpacing: "0.22em",
                color: "var(--color-gold)",
                mb: 1,
              }}
            >
              {item.eyebrow}
            </Typography> */}

            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 500,
                lineHeight: 1.5,
                maxWidth: "90%",
              }}
            >
              {item.title}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
